__turbopack_context__.v({
  "PostCard": "post-card-module__ZaxjqG__PostCard",
  "PostListMedia": "post-card-module__ZaxjqG__PostListMedia",
  "VideoShow": "post-card-module__ZaxjqG__VideoShow",
});
